var map = {
	"./edit.svg": "aa46",
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./loading.svg": "d412",
	"./password.svg": "2a3d",
	"./route/account-s.svg": "ef75",
	"./route/account.svg": "f982",
	"./route/company-auth-s.svg": "0c4b",
	"./route/company-auth.svg": "0774",
	"./route/company-s.svg": "cc19",
	"./route/company.svg": "55df",
	"./route/compliance-task-s.svg": "44a1",
	"./route/compliance-task.svg": "27b9",
	"./route/contract-s.svg": "c03e",
	"./route/contract.svg": "45d9",
	"./route/create-task-s.svg": "d150",
	"./route/create-task.svg": "9b97",
	"./route/crm-s.svg": "335e",
	"./route/crm.svg": "2c24",
	"./route/fast-package-s.svg": "9b92",
	"./route/fast-package.svg": "91ea",
	"./route/invoice-s.svg": "5315",
	"./route/invoice.svg": "1056",
	"./route/message-s.svg": "e63c",
	"./route/message.svg": "6325",
	"./route/payment-s.svg": "6cfc",
	"./route/payment.svg": "738b",
	"./route/secure-situation-s.svg": "de2d",
	"./route/secure-situation.svg": "8a0b",
	"./route/statements-s.svg": "228f",
	"./route/statements.svg": "4a45",
	"./route/task-manage-s.svg": "c52f",
	"./route/task-manage.svg": "bdfa",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";